(function () {
  'use strict';
  if (window.sidizMobileCommerce) return;
  window.sidizMobileCommerce = true;
  var media = window.matchMedia('(max-width: 1023px)');
  var instances = new Map();
  var homeSlot;
  function arrangeHome() {
    var nav = document.querySelector('.sidiz-mobile-shop-paths');
    var main = nav && nav.closest('main');
    var first = main && main.querySelector('.shopify-section');
    if (!nav || !first) return;
    if (!homeSlot || !homeSlot.isConnected) { homeSlot = document.createComment('mobile shop paths original position'); nav.before(homeSlot); }
    if (media.matches && document.body.dataset.sidizMobileCommerce === 'true') {
      if (nav.nextElementSibling !== first) main.insertBefore(nav, first);
      nav.setAttribute('data-sidiz-mobile-home-ready', '');
    } else { homeSlot.after(nav); nav.removeAttribute('data-sidiz-mobile-home-ready'); }
  }

  function init(root) {
    if (instances.has(root)) return;
    var panel = root.querySelector('.product-text--wrapper');
    if (!panel) return;
    var dock = root.querySelector('[data-sidiz-mobile-purchase-dock]');
    var button = root.querySelector('.product-actions button[name="add"]');
    var price = root.querySelector('[data-sidiz-price]');
    var jumps = root.querySelector('.sidiz-mobile-product-jumps');
    var purchaseSummary = root.querySelector('.sidiz-mobile-purchase-summary--selection');
    var purchaseReview = purchaseSummary
      ? [root.querySelector('.product-variant--wrapper'), purchaseSummary].filter(Boolean)
      : [];
    if (jumps) {
      var linked = new Set();
      document.querySelectorAll('[data-sidiz-sticky-nav] [data-sidiz-anchor]').forEach(function (link) {
        var id = link.dataset.sidizAnchor;
        if (!id || linked.has(id) || !document.getElementById(id)) return;
        var copy = document.createElement('a');
        copy.href = '#' + id;
        copy.textContent = link.textContent.trim();
        jumps.append(copy);
        linked.add(id);
      });
    }
    var original = Array.from(panel.children).map(function (node) {
      var marker = document.createComment('mobile purchase original position');
      node.before(marker);
      return { node: node, marker: marker };
    });
    var arranged = false;
    var pending = false;
    var enabled = function () { return media.matches && document.body.dataset.sidizMobileCommerce === 'true'; };

    function restore() {
      original.forEach(function (item) { if (item.marker.isConnected) item.marker.after(item.node); });
      var chat = panel.querySelector(':scope > .sidiz-webchat-inline');
      var actions = panel.querySelector(':scope > .product-actions');
      if (chat && actions) actions.after(chat);
      arranged = false;
    }
    function arrange() {
      if (!enabled()) { if (arranged) restore(); return; }
      if (arranged) return;
      // Move the existing nodes, never duplicate the product form or its properties.
      ['.product-price--wrapper', '.product-variant--wrapper', '.sidiz-mobile-purchase-summary', '.product-actions', '.product-payment--note', '.sidiz-webchat-inline', '.sidiz-mobile-product-jumps', '.product-delivery-and-warranty--wrapper', '.sidiz-mobile-product-resources', '.product-complementary--wrapper'].reverse().forEach(function (selector) {
        var node = panel.querySelector(':scope > ' + selector);
        if (node) panel.prepend(node);
      });
      arranged = true;
    }
    function rectVisible(node) {
      if (!node) return false;
      var rect = node.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && getComputedStyle(node).visibility !== 'hidden';
    }
    function overlayOpen() {
      if (document.body.classList.contains('sidiz-nav-open')) return true;
      if (document.querySelector('cart-drawer.active, cart-notification.active, dialog[open], .modal-360:not(.hidden)')) return true;
      var preview = document.getElementById('PBarNextFrameWrapper');
      if (preview && rectVisible(preview) && preview.getBoundingClientRect().height > 180) return true;
      return Array.from(document.querySelectorAll('#podium-website-widget iframe:not(#podium-bubble):not(#podium-prompt)')).some(function (frame) {
        var r = frame.getBoundingClientRect();
        return rectVisible(frame) && r.width > 200 && r.height > 200;
      });
    }
    function previewOffset() {
      var height = 0;
      document.querySelectorAll('#preview-bar-iframe, #PBarNextFrameWrapper, #PBarNextFrame').forEach(function (frame) {
        var r = frame.getBoundingClientRect();
        if (rectVisible(frame) && r.bottom >= window.innerHeight - 2 && r.height < 180) height = Math.max(height, r.height);
      });
      return height;
    }
    function update() {
      pending = false;
      arrange();
      if (jumps) jumps.hidden = !enabled() || !jumps.children.length;
      var current = price && price.querySelector('.product-price--best');
      root.querySelectorAll('[data-sidiz-mobile-price]').forEach(function (shownPrice) {
        if (current && shownPrice.textContent !== current.textContent) shownPrice.textContent = current.textContent;
      });
      var selection = Array.from(root.querySelectorAll('input[data-option-position]:checked')).map(function (input) { return input.value; }).join(' / ');
      root.querySelectorAll('[data-sidiz-mobile-selection]').forEach(function (shownSelection) {
        if (selection && shownSelection.textContent !== selection) shownSelection.textContent = selection;
      });
      if (!dock || !button) return;
      var active = enabled() && document.body.dataset.sidizMobileDock !== 'false';
      if (active) document.body.setAttribute('data-sidiz-mobile-dock-ready', '');
      else document.body.removeAttribute('data-sidiz-mobile-dock-ready');
      var offset = previewOffset();
      dock.style.setProperty('--sidiz-mobile-preview-offset', offset + 'px');
      var r = button.getBoundingClientRect();
      var mainButtonVisible = r.top >= 56 && r.bottom <= window.innerHeight - offset;
      var purchaseReviewVisible = purchaseReview.some(function (node) {
        var bounds = node.getBoundingClientRect();
        return bounds.width > 0 && bounds.height > 0 && bounds.bottom > 56 && bounds.top < window.innerHeight - offset && getComputedStyle(node).visibility !== 'hidden';
      });
      var keyboard = window.visualViewport && window.visualViewport.height < window.innerHeight * 0.7;
      dock.hidden = !active || mainButtonVisible || purchaseReviewVisible || overlayOpen() || keyboard;
      var availability = dock.querySelector('[data-sidiz-mobile-availability]');
      var atcLabel = button.querySelector('[data-sidiz-atc-label]');
      if (availability && atcLabel) {
        availability.hidden = !button.disabled;
        if (availability.textContent !== atcLabel.textContent.trim()) availability.textContent = atcLabel.textContent.trim();
      }
    }
    function schedule() { if (!pending) { pending = true; requestAnimationFrame(update); } }
    function choose(event) {
      var link = event.target.closest('[data-sidiz-mobile-choose]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var input = root.querySelector('input[data-sidiz-colour-option]:checked') || root.querySelector('input[data-option-position]:checked');
      var label = input && input.labels && input.labels[0];
      var target = label || button;
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      (input || button).focus({ preventScroll: true });
    }
    var observer = new MutationObserver(schedule);
    observer.observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    var bodyObserver = new MutationObserver(schedule);
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class', 'data-sidiz-mobile-commerce', 'data-sidiz-mobile-dock'], childList: true });
    var modalObserver = new MutationObserver(function (records) {
      if (records.some(function (record) {
        return record.target.nodeType === 1 && record.target.closest('cart-drawer, cart-notification, .modal-360, #podium-website-widget, #PBarNextFrameWrapper, dialog');
      })) schedule();
    });
    modalObserver.observe(document.body, { attributes: true, childList: true, subtree: true, attributeFilter: ['class', 'style', 'open'] });
    var intersection = new IntersectionObserver(schedule, { threshold: [0, 1] });
    if (button) intersection.observe(button);
    purchaseReview.forEach(function (node) { intersection.observe(node); });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    media.addEventListener('change', schedule);
    root.addEventListener('change', schedule);
    root.addEventListener('sidiz:variant-selected', schedule);
    if (dock) dock.addEventListener('click', choose);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule);
    instances.set(root, function () {
      observer.disconnect(); bodyObserver.disconnect(); modalObserver.disconnect(); intersection.disconnect();
      window.removeEventListener('scroll', schedule); window.removeEventListener('resize', schedule);
      media.removeEventListener('change', schedule); root.removeEventListener('change', schedule);
      root.removeEventListener('sidiz:variant-selected', schedule);
      if (dock) dock.removeEventListener('click', choose);
      if (window.visualViewport) window.visualViewport.removeEventListener('resize', schedule);
      restore(); original.forEach(function (item) { item.marker.remove(); });
      if (jumps) { jumps.replaceChildren(); jumps.hidden = true; }
      document.body.removeAttribute('data-sidiz-mobile-dock-ready');
    });
    update();
  }
  function boot() { arrangeHome(); document.querySelectorAll('[data-sidiz-configurator]').forEach(init); }
  media.addEventListener('change', arrangeHome);
  new MutationObserver(arrangeHome).observe(document.body, { attributes: true, attributeFilter: ['data-sidiz-mobile-commerce'] });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (cleanup, root) { if (event.target.contains(root)) { cleanup(); instances.delete(root); } });
  });
}());
